<template>
  <div class="w-full">
    <SmartTitle class="main-title" weight="medium">Calibração e Metas Adicionais</SmartTitle>
    <div class="flex align-center justify-end">
      <SmartButton style="width: 10rem" @click="toCreate" terceary icon :size="2">
        <div class="flex align-center">
          <SmartIcon class="mr-3" name="add" />Criar Meta
        </div>
      </SmartButton>
    </div>
    <div class="mt-4 main-section" v-if="!isLoading">
      <VDataTable
        hide-actions
        :items="additionalGoals"
        no-data-text="Nenhum dado a ser exibido"
        :headers="headersAdditional"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th>Produto</th>
            <th v-for="header in props.headers" :key="header.text" class="text-center">
              {{ header.text }}
              <br />
              <span class="sub-title">
                Fat. |
                <span class="vol-color">Vol.</span>
              </span>
            </th>
            <th>Editar</th>
            <th>Excluir</th>
          </tr>
        </template>
        <template v-slot:items="{ item, index }">
          <template>
            <td>{{ item.name }}</td>
            <td
              v-for="view in item.views"
              :key="view.id"
              class="text-center"
            >
              R$ {{ view ? view.faturamento : '-' }} |
              <span
                class="vol-color"
              >{{ view ? view.volume : '-' }}
              </span>

            </td>
            <td class="view-icon cursor-pointer">
              <SmartIcon @click="editGoal(item.id)" :size="2" name="edit" class="mr-1 ml-2" style="color: #eadd00" />
            </td>
            <td class="view-icon cursor-pointer">
              <SmartIcon @click="deleteGoal(item.id)" :size="2" name="trash" class="mr-1 ml-2" />
            </td>
          </template>
        </template>
      </VDataTable>
      <div>
        <div>
          <SmartModal
            :param="id"
            v-if="modal"
            v-bind="modal"
            @close.prevent="modal = null"
            @return="deleteGoalModal"
          >{{ modal.text }}</SmartModal>
        </div>
        <SmartDrawer @close="() => {showDrawer = false}" :show="showDrawer">
          <template v-slot:header>
            <SmartTitle class="text-black" weight="regular">{{ toCreateGoal ? 'Criar meta' : 'Editar meta' }}</SmartTitle>
          </template>
          <InfoAdditional @close="close()" :additionalGoal="additionalGoal" />
        </SmartDrawer>
      </div>
    </div>
    <div v-else>
      <SmartSkeletonLoading
        :items="15"
        :height="3"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { formatBRDateTime } from 'utils/date';
import { currencyFormat } from 'filters';

export default {
  filters: { currencyFormat, formatBRDateTime },
  components: {
    InfoAdditional: () => import('./InfoAdditional')
  },
  data() {
    return {
      showDrawer: false,
      TCN: [],
      TSE: [],
      TSP: [],
      TNE: [],
      TSL: [],
      items: [],
      modal: null,
      id: '',
      isLoading: false,
      toCreateGoal: true,
      additionalGoal: null,
      headers: [
        { text: 'TBR', value: 'to', sortable: false },
        { text: 'TSP', value: 'to', sortable: false },
        { text: 'TSE', value: 'current', sortable: false },
        { text: 'TCN', value: 'current', sortable: false },
        { text: 'TNE', value: 'current', sortable: false },
        { text: 'TSL', value: 'current', sortable: false }
      ],
      headersAdditional: [
        { text: 'TBR', value: 'to', sortable: false },
        { text: 'TSP', value: 'to', sortable: false },
        { text: 'TSE', value: 'current', sortable: false },
        { text: 'TCN', value: 'current', sortable: false },
        { text: 'TNE', value: 'current', sortable: false },
        { text: 'TSL', value: 'current', sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters({
      list: 'additionalGoals/list',
      additionalGoals: 'additionalGoals/additionalGoals',
      allBudgetsGetter: 'budget/allBudgetsGetter',
      allPagination: 'budget/allPagination',
      itemsGetter: 'additionalGoals/items'
    }),
    currentPage() {
      return this.allPagination && this.allPagination.current_page;
    }
  },
  methods: {
    ...mapActions({
      fetchList: 'additionalGoals/fetchList',
      fetchAdditionalGoals: 'additionalGoals/fetchAdditionalGoals',
      fetchAllBudgets: 'budget/fetchAllBudgets',
      deleteGoalAction: 'additionalGoals/deleteGoalAction'
    }),
    showDeleteModal() {
      this.modal = {
        type: 'warning',
        title: 'Ops! Vamos com calma...',
        icon: 'alert',
        buttonText: 'Cancelar',
        secondButton: 'Ok, excluir',
        text: 'Deseja realmente excluir este item?'
      };
    },
    showErrorModal() {
      this.modal = {
        type: 'warning',
        title: 'Ops! Algo deu errado...',
        icon: 'alert',
        buttonText: 'Ok',
        text: 'Iremos direcioná-lo para a página anterior'
      };
    },
    temFaturamento(index, value) {
      if (this.additionalGoals[index] !== false) {
        return value;
      }
      return false;
    },
    close() {
      this.showDrawer = false;
      this.modal = null;
      this.fetchAdditionalGoals();
    },
    toCreate() {
      this.additionalGoal = null;
      this.toCreateGoal = true;
      this.showDrawer = !this.showDrawer;
    },
    async editGoal(id) {
      this.id = id;
      this.additionalGoal = await this.additionalGoals.find(item => item.id === id);
      this.showDrawer = true;
      this.toCreateGoal = false;
      this.fetchAdditionalGoals();
    },
    deleteGoal(id) {
      this.id = id;
      this.showDeleteModal();
    },
    async deleteGoalModal() {
      await this.deleteGoalAction(this.id);
      this.fetchAdditionalGoals();
      this.modal = null;
      this.id = null;
    }
  },
  async mounted() {
    this.isLoading = true;
    await Promise.all([this.fetchAdditionalGoals(), this.fetchAllBudgets()])
      .catch(() => {
        this.showErrorModal();
      });
    this.isLoading = false;
  }
};
</script>

<style lang="scss">
table {
  tr:nth-child(even) {
    background: rgba(151, 151, 151, 0.05);
  }
}
.divP {
  width: 95px !important;
}
.name {
  width: 100px;
}
.card {
  height: 60px;
}
.inputsegment {
  width: 58px;
}
.first {
  height: 60px;
  background: rgba(229, 229, 229, 0.1);
}
.aux {
  width: fit-content;
  margin-left: 62px;
}
.head-div {
  width: 120px;
}
.sub-title {
  font-weight: 300;
  font-size: 14px;
  color: #737373;
}
.vol-color {
  color: $color-brand-secondary;
}
</style>
